<template>
	<div class="count-down" :style="{color,fontSize,fontStyle:italic?'italic':'normal'}">{{beforeTimeContent}}<span v-if="day>0">{{day+'天'}}</span> {{hour}}:{{minute}}:{{second}}</div>
</template>

<script>
	export default {
		props:{
			color : {
				type: String,
				default: "#DB6372"
			},
			fontSize:{
				type: String,
				default: ".14rem"
			},
			italic: {
				type: Boolean,
				default: false
			},
			beforeTimeContent:{
				type: String,
				default : ""
			},
			endTime:{
				type: [Date,String],
				default: ""
			}
		},
		data(){
			return {
				day: 0,
				hour : 0,
				minute : 0,
				second : 0,
				timer : null
			}
		},
		watch:{
			endTime:{
				handler(n,o){
					if(!n){ return; }
					this.timer && clearInterval(this.timer);
					this.init();
				},
				immediate: true
			}
		},
		created(){
			
		},
		mounted(){
			
		},
		destroyed(){
			console.log("========destroyed=========");
			this.timer && clearInterval(this.timer);
		},
		methods: {
			countDown() {
					// console.log("this.endTime: ",this.endTime);
					var nowTime = +new Date();//返回的是当前时间总的毫秒数
					var times = (this.endTime - nowTime) / 1000;//times 是剩余时间总的秒数
					// console.log("times: ",times);
					if (times<0) {
						this.timer && clearInterval(this.timer);
						this.second = '00';
						this.minute = "00";
						this.hour = "00";
						return;
					}
					var d = Math.floor(times / 60 / 60 / 24);
					// console.log("d: ",times / 60 / 60 / 24);
					this.day = d;
					var h = parseInt(times / 60 / 60 % 24);//计算小时
					h = h < 10 ? '0' + h : h;
					this.hour = h;
					var m = parseInt(times / 60 % 60);//计算分钟
					m = m < 10 ? '0' + m : m;
					this.minute = m;
					var s = parseInt(times % 60);//计算秒数
					s = s < 10 ? '0' + s : s;
					this.second = s;
					// console.log(this.hour,this.minute,this.second);
					if (d==0 && s == '00' && h == '00' && m == '00') {
						// this.second = '00';
						this.timer && clearInterval(this.timer);
						setTimeout(()=>{
								// alert('时间到了');
						}, 1);
					}
			},
			
			init(){
				console.log("down init================");

				this.countDown();//先调用一次防止第一次刷新页面有空白
				this.timer = setInterval(this.countDown, 1000);         //每隔一秒调用一次
			}
		}
	}
</script>

<style  scoped lang="stylus">
	
</style>